import { Moment } from "moment";
import { SimpleUser } from "./simple-user";

export class WpBookingRequestComment {

    public id: number | null = null;
    public createdBy: SimpleUser | null = null;
    public created: Moment | null = null;
    public lastModifiedBy: SimpleUser | null = null;
    public lastModified: Moment | null = null;

    constructor(
        public body: string | null
    ){}
}
